import { createClient } from '@supabase/supabase-js'
import { Database } from '../types/database.types'
import { API_CONFIG } from '../constants'

// Use constants instead of environment variables for production
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || API_CONFIG.SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || API_CONFIG.SUPABASE_ANON_KEY

// Get the current domain for OAuth redirects
const getRedirectUrl = () => {
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/auth/callback`
  }
  // Fallback for SSR
  return process.env.NODE_ENV === 'production' 
    ? 'https://salt-app-spiritual.netlify.app/auth/callback'
    : 'http://localhost:3000/auth/callback'
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    flowType: 'pkce', // Use PKCE flow for better OAuth handling
  },
})

// Export the redirect URL for use in OAuth flows
export const oauthRedirectUrl = getRedirectUrl()

// Platform-specific storage adapter
export const getStorageAdapter = () => {
  // Web uses localStorage, mobile will use AsyncStorage
  if (typeof window !== 'undefined') {
    return {
      getItem: (key: string) => localStorage.getItem(key),
      setItem: (key: string, value: string) => localStorage.setItem(key, value),
      removeItem: (key: string) => localStorage.removeItem(key)
    }
  }
  // Mobile will use AsyncStorage (configured later)
  return undefined
} 